<script lang="ts">
  import { gallery } from '../lib/gallery.svelte';
</script>

<button
  class="menu"
  class:open={gallery.panelOpen}
  aria-label={gallery.panelOpen ? 'Close menu' : 'Open menu'}
  aria-expanded={gallery.panelOpen}
  onclick={() => gallery.togglePanel()}
>
  <span></span>
  <span></span>
  <span></span>
</button>

<style>
  .menu {
    position: fixed;
    top: max(12px, env(safe-area-inset-top));
    left: max(12px, env(safe-area-inset-left));
    z-index: 30;
    width: 44px;
    height: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }

  .menu span {
    display: block;
    width: 20px;
    height: 2px;
    background: var(--fg);
    border-radius: 2px;
    transition:
      transform 0.3s var(--ease),
      opacity 0.2s var(--ease);
  }

  .menu.open span:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }
  .menu.open span:nth-child(2) {
    opacity: 0;
  }
  .menu.open span:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
  }
</style>
